import { PHYSICIAN_API_ENDPOINT } from "../config/constants"


export const updateProfileAPICall = async (payload) =>{
    try {
        const response = await fetch(PHYSICIAN_API_ENDPOINT, {
          method: 'POST',
          body: JSON.stringify(payload),
          headers: {
            'Access-Control-Allow-Origin': 'http://127.0.0.1:3000',
            'Access-Control-Allow-Methods': 'POST',
            'Access-Control-Allow-Headers': 'Content-Type',
            'Content-Type': 'application/json',
            'cache-control': 'no-cache',
          }
        })
        // const json = await response.json()
        // console.log('Success:', json)
        console.log('Success')
        return response
      } catch (error) {
        console.error('Error:', error)
        return error
      }
}